import React, { useState, useEffect } from "react";
import contactImage1 from "../../assets/images/users/user-1.jpg";
import penIcon from "../../assets/images/DeathModuleNew/penWhite.svg";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import moment from "moment";

export const ViewClientContacts = (props) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState(null);

  const getContactsGroup = async () => {
    try {
      setLoading(true);
      setGroups(null);
      let apiResponse = await DEATH_API.getContactGroup(props && props.contact && props.contact.id);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setGroups(apiResponse.groups);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    // Check if the URL contains the authorization code
    getContactsGroup();
  }, [(props.contact && props.contact.id)]);

  return (
    <div
      style={{
        background: "white",
        padding: "1rem",
        marginTop: "1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          width: "50%",
        }}
      >
        <div style={{ display: "flex" }}>
          <div className="chatCardInner" style={{ width: "80%" }}>
            {" "}
            <div className="chatCard" style={{ flexWrap: "nowrap" }}>
              {props && props.contact && props.contact.image ? (
                <div style={{ borderRadius: "50%" }}>
                  <img
                    src={props.contact.image}
                    height={"48px"}
                    width={"48px"}
                    alt={"new"}
                    style={{ borderRadius: "1rem" }}
                  />
                </div>
              ) : (
                <div className="contactLogo">
                  {/* item.name.charAt(0).toUpperCase() */}
                  {props && props.contact && props.contact.name
                    ? props.contact.name
                        .split(" ")
                        .map((part) => part[0])
                        .join("")
                    : "N/A"}
                </div>
              )}
              <div className="chatCardDesc">
                <span className="chatName">
                  {props && props.contact && props.contact.name ? props.contact.name : "N/A"}
                </span>
                <span className="chatValue" style={{}}>
                  {props && props.contact && props.contact.phoneNumber
                    ? props.contact.phoneNumber
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div style={{ width: "20%" }}>
            <button
              className=""
              style={{
                background: "#2a3da3",
                width: "30px",
                height: "30px",
                outline: "none",
                border: "none",
                borderRadius: "4px",
              }}
              onClick={() => {
                props.editContacts(true);
                props.viewContacts(false);
              }}
            >
              <img src={penIcon}></img>
            </button>
          </div>
        </div>
        <div style={{ padding: "2rem" }}>
          <div>
            <div className="infocardrow" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.email && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Email</span>
                    <span
                      className="infocardsubTitle"
                      style={{ wordWrap: "break-word" }}
                    >
                      {props.contact.email ? props.contact.email : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.phoneNumber && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Phone Number </span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.phoneNumber
                        ? props.contact.phoneNumber
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && (props.contact.workStreet ||
                  props.contact.workCity ||
                  props.contact.workState) && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Address (Work)</span>
                    <span className="infocardsubTitle">
                      {props.contact.workStreet ? props.contact.workStreet : ""}
                    </span>
                    <span className="infocardsubTitle">
                      {props.contact.workCity ? props.contact.workCity : ""}
                    </span>
                    <span className="infocardsubTitle">
                      {props.contact.workState ? props.contact.workState : ""}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {groups && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Group</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {groups &&
                        groups.map((item, index) => (
                          <button
                            className="savebutton"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: "600",
                              padding: "10px 10px",
                              marginBottom: "4px",
                              // width: "90px",
                            }}
                            type="submit"
                          >
                            {item.groupName}
                          </button>
                        ))}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.jobCompany && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Job</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.jobCompany
                        ? props.contact.jobCompany
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.socialProfiles && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Social Profiles</span>
                    <span className="infocardsubTitle">
                      {props.contact.socialProfiles
                        ? props.contact.socialProfiles
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.workWebPage && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Webpage</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.workWebPage
                        ? props.contact.workWebPage
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.birthday && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Birthday</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.birthday
                        ? moment(props.contact.birthday).format("MM-DD-YYYY")
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.onAirDate && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Other Date</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.onAirDate
                        ? moment(props.contact.onAirDate).format("MM-DD-YYYY")
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
